import { type FeatureFlagsInterface } from "@finway-group/shared/lib/models"
import { type ActionCreator, type Dispatch } from "redux"
import { type ThunkResult } from "~Shared/store"
import { FeatureFlagsActionTypes, type SetFeatureFlagsAction } from "~Shared/store/actions/featureFlags/featureFlagsTypes"

export const setFeatureFlags: ActionCreator<ThunkResult<FeatureFlagsInterface>> = (featureFlags: FeatureFlagsInterface) => async (dispatch: Dispatch) => {
    const setFeatureFlagsAction: SetFeatureFlagsAction = {
        type: FeatureFlagsActionTypes.SET_FEATURE_FLAGS,
        featureFlags,
    }
    dispatch(setFeatureFlagsAction)

    return featureFlags
}
